export type {
    LanguageItem,
    AccentItem,
    ToneItem,
    StyleItem,
    AIVoiceFilters,
} from 'js/src/data/ai-voices-and-avatars/ai-voices/ai-voices-slices';

export enum ACTIONS {
    SET_AI_AVATAR_VOICE_PRESETS = 'SET_AI_AVATAR_VOICE_PRESETS',
    SET_AI_AVATARS = 'SET_AI_AVATARS',
    SET_AI_VOICEOVER_BATCH_COMPLETE = 'SET_AI_VOICEOVER_BATCH_COMPLETE',
}
